import { render, staticRenderFns } from "./openScreenAdd.vue?vue&type=template&id=498d5259"
import script from "./openScreenAdd.vue?vue&type=script&lang=js"
export * from "./openScreenAdd.vue?vue&type=script&lang=js"
import style0 from "./openScreenAdd.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports